
const patterns = {
    username: /^(?!\s*$).{1,50}$/i,
    password: /^[\d\w@-]{8,20}$/i,
    email: /^([a-z\d\.-]+)@([a-z\d-]+)\.([a-z]{2,8})(\.[a-z]{2,8})?$/,
    phone: /^\+?\d{10,}$/,
    address: /^(?!\s*$).{1,255}$/i
};

function validate(field, regex) {
    if (!regex) {
        return;
    }
    const isValid = regex.test(field.value);
    $(field).toggleClass('valid', isValid).toggleClass('invalid', !isValid);
}

function validateForm($form) {
    if (!$form) {
        return false;
    }
    const $inputs = $form.find('.form-control');

    // $inputs.on('keyup', function() {
    //     validate(this, patterns[this.getAttribute('id')]);
    // });

    // Validate each input initially
    $inputs.each(function() {
        validate(this, patterns[this.getAttribute('id')]);
    });

    // Check if any field has the 'invalid' class
    const isFormValid = $inputs.filter('.invalid').length === 0;

    return isFormValid;
}

function getForm($form) {
    var formData = {};

    // Iterate over all input fields in the form
    $form.find('.form-control').each(function () {
        var inputId = $(this).attr('id');
        formData[inputId] = $(this).val();
    });

    return formData;
}
// Execute the validation for all existing forms using jQuery
function verifyInputs() {
    $('body').find('form').each(function() {
        const $inputs = $(this).find('.form-control');
        $inputs
        .off('keyup')
        .on('keyup', function() {
            validate(this, patterns[this.getAttribute('id')]);
        });
        //validateForm($(this));
    });
}

$(window).on('load', function() {
    verifyInputs();
});

module.exports = {
    validateForm: validateForm,
    getForm: getForm,
    verifyInputs: verifyInputs
};